const switchButtons = document.querySelectorAll('.de-SwatchObjects-item');
const productTitleElement = document.querySelector('.js-de-TitleInfo');

switchButtons.forEach(function(button) {
    button.addEventListener('click', function() {
        let models = document.querySelector("#models").innerHTML;
        let actualModelCode = document.querySelector('[itemprop="model"]').innerHTML;
        let selectedModelCode = button.getAttribute('data-model-code');
        if (selectedModelCode !== actualModelCode) {
        actualModelCode = selectedModelCode;
        let title = getTitleByModelCode(selectedModelCode, models);
        updateProductTitle(title);
        }
    });
});


function getTitleByModelCode(modelCode, models) {
    const modelArray = Object.values(JSON.parse(models));
    const foundModel = modelArray.find(model => model.modelCode === modelCode);

    return foundModel ? foundModel.title : null;
}

function updateProductTitle(newTitle) {
    if(newTitle !== null) {
    productTitleElement.textContent = newTitle;
    }
}